import React, { Component } from "react";
import FormGroupCheckBox from "../shared/form/FormGroupCheckbox";
import { connect } from "react-redux";
import {
    setIsValueChanged
} from "../../actions/policy/policyActions";

const mapDispatchToProps = (dispatch) => {
    return {
        setIsValueChanged: (Value) => dispatch(setIsValueChanged(Value))
    };
};

export class OnboardingContactPreferenceSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ContactPreference: [],
        };
        this.preferenceChanges = this.preferenceChanges.bind(this);
        this.updatedValue = this.updatedValue.bind(this);
    }

    updatedValue(contactValue) {
        if (contactValue !== null) {
            this.setState({
                ContactPreference: contactValue,
            });
        }
        else {
            this.setState({
                ContactPreference: [],
            });
        }

    }

    preferenceChanges(event, ContactPreferenceId) {
        this.isContactPrefValueChanged(true);
        this.props.setIsValueChanged(true);
        const contact = this.state.ContactPreference;

        const index = contact.findIndex(m => m.ContactPreferenceId === ContactPreferenceId);
        const masterData = this.props.contactPrefsKeys.filter((val) => val.ContactPreferenceId === ContactPreferenceId);
        if (index !== -1) {
            let existflag = [];

            if (existflag.length !== 0 && contact[index].PersonContactPrefId !== 0) {
                //Add or delete from existing preference(Yes->No)
                contact[index].IsDeleted = event.target.value === "false" ? true : false;
            } else {
                // Delete entry from existing array(No->Yes->No)
                contact.splice(index, 1);
            }
            this.setState({
                ContactPreference: contact
            });
        }
        else {
            //New entry(No -> yes)
            let newValue;

            newValue = {
                PersonContactPrefId: 0,
                PersonId: "",
                ContactPreferenceId: masterData[0].ContactPreferenceId,
                ContactPreferenceName: masterData[0].ContactPreferenceName,
                CreatedBy: this.props.MemberName,
                LastUpdatedBy: this.props.MemberName,
                SourceSystem: "",
                SourcePersonId: "",
                IsDeleted: false
            };
            const newArrayVal = this.state.ContactPreference;
            newArrayVal.push(newValue);
            this.setState({
                ContactPreference: newArrayVal
            });
        }
        if (this.state.ContactPreference.length === 0) {
            this.props.setIsValueChanged(false);
        }
        this.updateContactPreferences(this.state.ContactPreference);
    }

    updateContactPreferences(contactprefs) {
        this.props.updateContactPreferences(contactprefs);
    }

    isContactPrefValueChanged(value) {
        this.props.isContactValueChanged(value);
    }
    render() {
        if (this.props.contactPrefsKeys !== undefined && this.props.contactPrefsKeys !== null) {
            return this.props.contactPrefsKeys.length > 0 && this.props.contactPrefsKeys.map(informMethod => {
                let contactOptionValue = false;

                return (
                    <FormGroupCheckBox
                        className={"form-group mt-0"}
                        type="checkbox"
                        id={"contact" + informMethod.ContactPreferenceName}
                        label={informMethod.ContactPreferenceName}
                        key={informMethod.ContactPreferenceName}
                        currentValue={contactOptionValue}
                        onChange={(event) => {
                            this.preferenceChanges(event, informMethod.ContactPreferenceId);
                            return event.target.value === "true"
                                ? true
                                : event.target.value === "false"
                                    ? false
                                    : null;
                        }
                        }
                        Zebrafied={this.props.Zebrafied}
                        UseSlider={this.props.UseSlider}
                        mfa={this.props.mfa}
                    />
                );
            });
        }
        return null;
    }
}

export default connect(
    null,
    mapDispatchToProps
)(OnboardingContactPreferenceSection);